import styled from "styled-components";
import { Title, LARGE, MOBILE, BodyText } from "@minerva-analytics/pantheon";

export const HomeTitle = styled(Title)`
  @media (max-width: ${LARGE}) {
    text-align: center;
  }

  @media (min-width: ${LARGE}) {
    max-width: 38rem;
  }
`;

export const TypeformContainer = styled.div`
  position: relative;
  width: 100%;
  margin-left: -3rem;
  margin-top: -1rem;
  min-height: 45rem;

  @media (max-width: ${MOBILE}) {
    margin-left: -1rem;
  }
  iframe {
    min-height: 45rem;
  }
`;

export const SubscribeBodyText = styled(BodyText)`
  max-width: 90%;
`;
